import React from 'react';
import { Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { unitResponsesStyles } from './styles';
import { unitLabel } from '@common/services/unitUtils';

const VcmCourseRemovedUnits = ({ classes, units }) => {
  if (!units?.length) {
    return null;
  }

  return (
    <div className={classes.paddedContainer}>
      <Typography className={classes.smallLabel}>
        Units the educator has removed from this course:
      </Typography>
      {units.map((unit) => (
        <Typography key={unit.id} className={classes.body2}>
          {unitLabel(unit)}
        </Typography>
      ))}
    </div>
  );
};

export default withStyles(VcmCourseRemovedUnits, unitResponsesStyles, {
  withTheme: true
});
